import React from 'react';
import {
  TextInput,
  Filter as FilterAdmin,
  ReferenceInput,
  SelectInput,
  AutocompleteInput,
} from 'react-admin';

import { STATUS_ATIVO } from '../../utils/constants';
import { choicesTipo } from './choices';

const Filter = (props) => (
  <FilterAdmin {...props}>
    <TextInput label="Descrição" source="nome" />
    <TextInput label="Código de barras" source="codigo" />
    <SelectInput
      source="tipo"
      choices={choicesTipo}
      allowEmpty={false}
      alwaysOn
    />
    <ReferenceInput
      fullWidth
      label="Fornecedor"
      source="fornecedor_id"
      reference="fornecedores"
      sort={{ field: 'nome', order: 'ASC' }}
      filterToQuery={(searchText) => ({ nome: `${searchText}` })}
      perPage={30}
      filter={{ status: STATUS_ATIVO }}
    >
      <AutocompleteInput optionText="nome" />
    </ReferenceInput>
    <ReferenceInput
      fullWidth
      label="Categoria"
      source="categoria_id"
      reference="categorias"
      sort={{ field: 'nome', order: 'ASC' }}
      filterToQuery={(searchText) => ({ nome: `${searchText}` })}
      perPage={30}
    >
      <AutocompleteInput optionText="nome" />
    </ReferenceInput>
    <ReferenceInput
      source="familia_produto_id"
      reference="familias_produtos"
      label="Família"
      allowEmpty={false}
    >
      <SelectInput optionText="nome" allowEmpty={false} />
    </ReferenceInput>
    <ReferenceInput
      label="Unidade"
      source="unidade_id"
      reference="unidades"
      allowEmpty={false}
      filter={{ status: STATUS_ATIVO }}
    >
      <SelectInput optionText="nome" allowEmpty={false} />
    </ReferenceInput>
  </FilterAdmin>
);

export default Filter;
